import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
  getMyWorksToControl: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL].GET_MY_WORKS_TO_CONTROL
  },
}